module.exports = __webpack_public_path__ + "img/aji_name.0ea79af4.svg";